import Config from '@config';
import { initializeSubdivisionsApi } from '@gasbi/shared/common/features/subdivisions';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

// Структурні підрозділи of a ГРМ are created and edited only here (PO, 2026-10-27), over the BMS routes and shapes
// (structural-subdivisions). Their representative and signatory are BMS's data, which the admin assigns in BMS (PO,
// 2026-10-30, GSB-8515).
export const {
  subdivisionsApi,
  useGetSubdivisionsInfiniteQuery,
  useCreateSubdivisionMutation,
  useUpdateSubdivisionByIdMutation,
} = initializeSubdivisionsApi(Config.VITE_API_URL, axiosBaseQuery);
